import React, { FunctionComponent } from 'react'
import styles from './AiIconGradient.module.css'

/*
 * The AI gradient for outline icons (e.g. the lightbulbs beside AI-written insights): green into teal, holding
 * purple, as on Mission Control. Render <AiIconGradient /> once near the icons, then stroke their paths with
 * `url(#pi-ai-icon-gradient)`. It's in user space across the 16-unit icon box, so even the straight rays (which
 * have no width or height of their own) take it. Every copy defines the same gradient, so repeats are harmless.
 */
export const AI_ICON_GRADIENT_ID = 'pi-ai-icon-gradient'

export const AiIconGradient: FunctionComponent = () => (
  <svg width='0' height='0' aria-hidden='true' focusable='false' className={styles.defs}>
    <defs>
      <linearGradient id={AI_ICON_GRADIENT_ID} gradientUnits='userSpaceOnUse' x1='0' y1='0' x2='15' y2='15'>
        <stop offset='0' stopColor='#27aa27' />
        <stop offset='.37' stopColor='#32c2af' />
        <stop offset='.7' stopColor='#ab87ff' />
        <stop offset='1' stopColor='#ab87ff' />
      </linearGradient>
    </defs>
  </svg>
)
